import { Select } from "../../../../design/select";
import { AccountSubtype, AccountType } from "plaid";

interface Props {
  type?: AccountType;
  setType: (type: AccountType) => void;
  setSubtype?: (subtype: AccountSubtype) => void;
}

const FinancialAccountFilters: React.FC<Props> = ({ type, setType }) => {
  return (
    <div>
      <Select
        value={type}
        onChange={(e) => setType(e.target.value as AccountType)}
        className="w-full"
      >
        <option value="">All</option>
        <option value="depository">Depository</option>
        <option value="investment">Investment</option>
        <option value="credit">Credit</option>
        <option value="loan">Loan</option>
        <option value="other">Other</option>
      </Select>
    </div>
  );
};

export default FinancialAccountFilters;
